export default __webpack_public_path__ + "static/media/heading-block-thumbnail-dark.117e92b0.svg";